import { useEffect, useState } from 'react'
import axios from 'axios'

let invoicingPromise: Promise<string[]> | null = null
let divisionPromise: Promise<string[]> | null = null
let endUserPromise: Promise<string[]> | null = null

export function usePortalInvoicingPlatformList() {
  const [list, setList] = useState<string[]>([])
  useEffect(() => {
    if (!invoicingPromise) {
      invoicingPromise = axios.get('/portal/invoicingPlatformList').then(r => r.data as string[])
    }
    invoicingPromise.then(setList).catch(err => console.error(err))
  }, [])
  return list
}

export function usePortalDivisionList() {
  const [list, setList] = useState<string[]>([])
  useEffect(() => {
    if (!divisionPromise) {
      divisionPromise = axios
        .get('/portal/segmentList?segment=division')
        .then(r => (r.data as { name: string }[]).map(({ name }) => name))
    }
    divisionPromise.then(setList).catch(err => console.error(err))
  }, [])
  return list
}

export function usePortalEndUserList() {
  const [list, setList] = useState<string[]>([])
  useEffect(() => {
    if (!endUserPromise) {
      endUserPromise = axios
        .get('/portal/segmentList?segment=enduser')
        .then(r => (r.data as { name: string }[]).map(({ name }) => name))
    }
    endUserPromise.then(setList).catch(err => console.error(err))
  }, [])
  return list
}
